// ---------------------------------------------------------------------------
// 銀行明細「freee 登録済・消込だけ自動リトライ待ち」の判定 (2026-09-14)
//
// 背景 (wallet_txn 2438715451 incident): mechanical-approve / register-after-approve は
//   freee deal POST 成功後に消込 preview が失敗すると、 processing_status='error' +
//   reconcile_state='reconcile_pending' に落として HTTP 502 を返す。 */10 cron
//   (bankRetryPendingReconciles) が自動で再消込するため実害は無いが、 UI は「失敗」と
//   表示しており、 誤認 → freee UI での手動登録 (二重計上) を招く導線になっていた。
//
// 安全側の原則: 判定が曖昧なときは必ず「従来のエラー表示」に倒す。
//   - 応答判定は 3 条件 (HTTP 502 / reconcile_state='reconcile_pending' / freee_deal_id>0)
//     すべて満たす場合のみ。 Cloudflare 自体の 502 (HTML body) や freee_post_failed
//     (deal 未作成) は該当しない。
//   - 行判定は worker が reconcile_state を返せばそれが常に正。 未返却 (現状の list API) の
//     場合のみ error_message の接頭辞 + freee_deal_id から推定する。 終端
//     (bank_reconcile_retry_terminal:) と差額 (GATE_68b) は推定対象外。
// ---------------------------------------------------------------------------

/** 自動リトライ (10分周期・上限6回) が進んでいないとみなす経過分 */
export const RECONCILE_PENDING_STALE_MINUTES = 70;

/** 自動回復が遅延している行のバッジ表示名 */
export const RECONCILE_STALE_LABEL = '消込遅延(要確認)';

// worker.js が reconcile_pending と同時に書く error_message の接頭辞。
//   mechanical_reconcile_failed:              mechanical-approve
//   register_after_approve_reconcile_failed:  register-after-approve
//   bank_reconcile_retry:                     cron リトライ中 (終端は bank_reconcile_retry_terminal: で不一致)
const PENDING_ERROR_MESSAGE = /^(mechanical_reconcile_failed|register_after_approve_reconcile_failed|bank_reconcile_retry): /;

export interface ReconcileProcessingLike {
  processing_status?: string | null;
  freee_deal_id?: number | null;
  error_message?: string | null;
  reconcile_state?: string | null;
}

export function isReconcilePendingResponse(status: number, body: any): boolean {
  return status === 502
    && !!body
    && body.reconcile_state === 'reconcile_pending'
    && Number(body.freee_deal_id) > 0;
}

export function effectiveReconcileState(
  p: ReconcileProcessingLike | null | undefined,
  topLevelReconcileState?: string | null,
): string | null {
  if (!p || p.processing_status !== 'error') return null;
  if (p.reconcile_state !== undefined) return p.reconcile_state ?? null;
  if (topLevelReconcileState !== undefined) return topLevelReconcileState ?? null;
  if (Number(p.freee_deal_id) > 0 && PENDING_ERROR_MESSAGE.test(p.error_message || '')) {
    return 'reconcile_pending';
  }
  return null;
}

/** last_updated は D1 datetime('now') = UTC の 'YYYY-MM-DD HH:MM:SS' */
export function isReconcilePendingStale(lastUpdated: string | null | undefined, now: number = Date.now()): boolean {
  if (!lastUpdated) return false;
  const iso = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(lastUpdated)
    ? `${lastUpdated.replace(' ', 'T')}Z`
    : lastUpdated;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return false;
  return now - t > RECONCILE_PENDING_STALE_MINUTES * 60 * 1000;
}

export function reconcilePendingToastText(freeeDealId: number | string, walletTxnId: number): string {
  return `freee 登録は完了 (deal #${freeeDealId})。消込だけ保留になりましたが、自動リトライで通常10分以内に完了します — 再操作は不要です (wtId=${walletTxnId})`;
}
